import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LeadDetailsComp } from './leaddetails';
import { AddNewUser, GetProcessList, GetUserDetails, UpdateUserDetails } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetAllProject, GetAreasList, GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import { AddNewLead, GetAllLeads, UpdateLead, UpdateLeadDesc } from '../../models/leads';
import { GetProfileList } from '../../models/profile';
import { GetUserList } from '../../models/user';

export const LeadDetails = () => {
    const userData = useUserStore;
    const [tabName, setTabName] = useState('Customer Details');
    const [LeadFormData, setLeadFormData] = useState({
        'txtInterviewDate': new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '),
        'txtJoiningDate': new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '),
    });
    const [sourceListData, setSetSourceListData] = useState(['Organic', 'Google', 'Meta']);
    const [getStateList, setGetStateList] = useState(true);
    const [stateListData, setStateListData] = useState([]);
    const [getCityList, setGetCityList] = useState(false);
    const [cityListData, setCityListData] = useState([]);
    const [getAreaList, setGetAreaList] = useState(false);
    const [areaListData, setAreaListData] = useState([]);
    const [getProfileList, setGetProfileList] = useState(true);
    const [profileListData, setProfileListData] = useState([]);
    const [getUserList, setGetUserList] = useState(true);
    const [userListData, setUserListData] = useState([]);
    const [getProjectList, setGetProjectList] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [investmentSizeList, setInvestmentSizeList] = useState([]);
    const [projectSearchObj, setProjectSearchObj] = useState({});
    const [getLeadDetails, setGetLeadDetails] = useState(false);
    const [leadDetails, setLeadDetails] = useState([]);
    const [leadSearchObj, setLeadSearchObj] = useState({});
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(20);

    const [openDescriptionBox, setOpenDescriptionBox] = useState(false);
    const [openProjectDetailsBox, setOpenProjectDetailsBox] = useState(false);
    const [mode, setMode] = useState('add');
    const [addLead, setAddLead] = useState(false);
    const [editLead, setEditLead] = useState(false);
    const [updateLeadDesc, setUpdateLeadDesc] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');
    const [statusListArray, setStatusListArray] = useState([]);
    const [interviewstatusListArray, setInterviewStatusListArray] = useState([]);
    const [joiningstatusListArray, setJoiningStatusListArray] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const state = {
        userData: userData.getState(),
        tabName: tabName,
        mode: mode,
        addUser: addLead,
        editUser: editLead,
        openDescriptionBox: openDescriptionBox,
        openProjectDetailsBox: openProjectDetailsBox,
        leadDetails: leadDetails,
        stateListData: stateListData,
        profileListData: profileListData,
        userListData: userListData,
        investmentSizeList: investmentSizeList,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        sourceListData: sourceListData,
        statusListArray: statusListArray,
        interviewstatusListArray: interviewstatusListArray,
        joiningstatusListArray: joiningstatusListArray
    }

    useEffect(() => {
        //console.log(userData.getState())
        let lead_id = params.lead_id;
        //alert(lead_id);
        if (lead_id !== undefined && lead_id !== null && lead_id !== '' && lead_id !== 'new') {

            setMode('edit');
            setLeadSearchObj({
                'txtLeadId': lead_id
            })
            setGetLeadDetails(true);
            setLeadFormData((prev) => ({ ...prev, ['txtLeadId']: lead_id }));
        }
        else {
            let statusListArray = ['Pending', 'DNP', 'Interested', 'Not Interested', 'Not Qualified', 'Call Later', 'Interview Scheduled'];
            let interviewstatusListArray = ['Interview Scheduled', 'Interview Pending', 'Interview Completed', 'Selected', 'Rejected', 'Backed Out', 'On Board'];
            let joiningstatusListArray = ['Joining', 'Rejected', 'Registration Completed', 'Attending Online Classes', 'On Hold'];
            setStatusListArray(statusListArray);
            setInterviewStatusListArray(interviewstatusListArray);
            setJoiningStatusListArray(joiningstatusListArray)
        }

        setProjectSearchObj({
            'set_no': setNo,
            'per_set': perSet,
        })

        setGetProjectList(true);

        if (userData.getState().profile === 'IFA') {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadSource']: 'IFA' }));
            setLeadFormData((prev) => ({ ...prev, ['ddlIFAName']: userData.getState().username }));
        }

    }, []);


    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtInterviewDate' || name === 'txtJoiningDate') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
            value = e.target.value
        }

        if (name === 'txtMobileNumber' || name === 'txtLeadPincode' || name === 'txtCandidateAge') {
            value = value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
            setAddLead(false);
        }

        setLeadFormData((prev) => ({ ...prev, [name]: value }));
        if (name == 'ddlLeadState') {
            setGetCityList(true)
        }
        if (name == 'ddlLeadDistrict') {
            setGetAreaList(true)
        }
    }

    const SaveOrUpdateLead = () => {
        //  console.log(LeadFormData.txtLeadPincode);
        let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (LeadFormData.txtCandidateName == undefined || LeadFormData.txtCandidateName == null || LeadFormData.txtCandidateName.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtCandidateNameErr']: 'Please Enter User Name' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['txtCandidateNameErr']: '' }));
        }


        if (LeadFormData.txtMobileNumber == undefined || LeadFormData.txtMobileNumber == null || LeadFormData.txtMobileNumber.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtMobileNumberErr']: 'Please Enter User Number' }));
            return false;
        }
        else {
            if (LeadFormData.txtMobileNumber.trim().length >= 10) {
                setLeadFormData((prev) => ({ ...prev, ['txtMobileNumberErr']: '' }));

            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['txtMobileNumberErr']: 'Please Enter Correct Number' }));
                return false;
            }
        }

        if (LeadFormData.txtEmailId == undefined || LeadFormData.txtEmailId == null || LeadFormData.txtEmailId.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtEmailIdErr']: 'Please Enter User Email' }));
            return false;
        }
        else {
            if (emailRegex.test(LeadFormData.txtEmailId)) {
                setLeadFormData((prev) => ({ ...prev, ['txtEmailIdErr']: '' }));
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['txtEmailIdErr']: 'Please Enter User Email' }));
                return false;
            }
        }

        if (LeadFormData.txtPatchDateTime !== undefined && LeadFormData.txtPatchDateTime !== null && LeadFormData.txtPatchDateTime !== '') {


            if (LeadFormData.ddlLeadState == undefined || LeadFormData.ddlLeadState == null || LeadFormData.ddlLeadState.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadStateErr']: 'Please Select State' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadStateErr']: '' }));
            }

            if (LeadFormData.ddlLeadDistrict == undefined || LeadFormData.ddlLeadDistrict == null || LeadFormData.ddlLeadDistrict.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadDistrictErr']: 'Please Select District' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadDistrictErr']: '' }));
            }

            if (LeadFormData.ddlCandidateGender == undefined || LeadFormData.ddlCandidateGender == null || LeadFormData.ddlCandidateGender.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateGenderErr']: 'Please Select Gender' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateGenderErr']: '' }));
            }

            if (LeadFormData.txtCandidateAge == undefined || LeadFormData.txtCandidateAge == null || LeadFormData.txtCandidateAge.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['txtCandidateAgeErr']: 'Please Enter Age' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['txtCandidateAgeErr']: '' }));
            }

            if (LeadFormData.ddlCandidateExp == undefined || LeadFormData.ddlCandidateExp == null || LeadFormData.ddlCandidateExp.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateExpErr']: 'Please Select Work Experiece' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateExpErr']: '' }));
            }

            if (LeadFormData.ddlCandidateQual == undefined || LeadFormData.ddlCandidateQual == null || LeadFormData.ddlCandidateQual.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateQualErr']: 'Please Select Qualification' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateQualErr']: '' }));
            }

            if (LeadFormData.ddlCandidateBatchTime == undefined || LeadFormData.ddlCandidateBatchTime == null || LeadFormData.ddlCandidateBatchTime.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateBatchTimeErr']: 'Please Select Batch Time' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlCandidateBatchTimeErr']: '' }));
            }

        }

        if (LeadFormData.ddlLeadSource == undefined || LeadFormData.ddlLeadSource == null || LeadFormData.ddlLeadSource.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadSourceErr']: 'Please Select Source' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadSourceErr']: '' }));
        }

        if (LeadFormData.ddlLeadStatus == undefined || LeadFormData.ddlLeadStatus == null || LeadFormData.ddlLeadStatus.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadStatusErr']: 'Please Select Lead Status' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadStatusErr']: '' }));
        }

        if (userData.getState().profile === 'Sales') {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadDepartment']: 'Sales' }));
        }
        else {

            if (LeadFormData.ddlLeadDepartment == undefined || LeadFormData.ddlLeadDepartment == null || LeadFormData.ddlLeadDepartment.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: 'Please Select Department' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: '' }));
            }
        }

        if (userData.getState().profile === 'Sales') {
            setLeadFormData((prev) => ({ ...prev, ['ddlLeadOwner']: userData.getState().name }));
        }
        else {
            if (LeadFormData.ddlLeadOwner == undefined || LeadFormData.ddlLeadOwner == null || LeadFormData.ddlLeadOwner.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: 'Please Select Lead Owner' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: '' }));
            }
        }

        if (LeadFormData.ddlLeadStatus === 'Interview Scheduled') {
            if (LeadFormData.ddlInterviewerName == undefined || LeadFormData.ddlInterviewerName == null || LeadFormData.ddlInterviewerName.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlInterviewerNameErr']: 'Please Select Interviewer' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlInterviewerNameErr']: '' }));
            }

        }


        if (LeadFormData.ddlInterviewStatus === 'Joined') {

            if (LeadFormData.ddlClassMode == undefined || LeadFormData.ddlClassMode == null || LeadFormData.ddlClassMode.trim() == '') {
                setLeadFormData((prev) => ({ ...prev, ['ddlClassModeErr']: 'Please Select Class Mode' }));
                return false;
            }
            else {
                setLeadFormData((prev) => ({ ...prev, ['ddlClassModeErr']: '' }));
            }
        }

        if (LeadFormData.txtLeadDesc == undefined || LeadFormData.txtLeadDesc == null || LeadFormData.txtLeadDesc.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadDescErr']: 'Please Enter Note' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadDescErr']: '' }));
        }

        console.log('I AM HERE');
        console.log(LeadFormData);

        if (mode == 'add') {
            setAddLead(true);
        }
        else {
            setEditLead(true);
        }
    }

    const ToggleDescriptionBox = () => {
        if (openDescriptionBox == true) {
            setOpenDescriptionBox(false);
        }
        else {
            setOpenDescriptionBox(true);
        }
    }

    const ToggleProjectDetailsBox = () => {
        if (openProjectDetailsBox == true) {
            setOpenProjectDetailsBox(false);
        }
        else {
            setOpenProjectDetailsBox(true);
        }
    }

    const AddDescription = () => {
        if (LeadFormData.txtLeadComment == undefined || LeadFormData.txtLeadComment == null || LeadFormData.txtLeadComment.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadCommentErr']: 'Please Enter Comment' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadCommentErr']: '' }));
        }


        //  alert('pppp')

        // if (mode == 'add') {
        //     ToggleDescriptionBox();
        // }
        // else {
        // in edit mode call desction add waali api
        setUpdateLeadDesc(true);
        //}
    }

    const HandleCityListResponse = (res) => {
        if (res != false) {
            let data = res.data.districtlistresponse.rows;

            setCityListData(data);

            if (mode == 'edit') {
                setGetAreaList(true)
            }
        }
        else {
            setCityListData([]);
        }

        setGetCityList(false);
    }

    const HandleAreaListResponse = (res) => {
        if (res != false) {
            let data = res.data.arealistresponse.rows;
            setAreaListData(data);
        }
        else {
            setAreaListData([]);
        }
        setGetAreaList(false);

    }

    const HandleAddNewLeadResponse = (res) => {
        setAddLead(false);
        if (res != false) {
            console.log(res.data.leadsresponse.message.value);
            // setAlertType('success')
            // setAlertMsg(res.data.propentryresponse.message.value);
            // HandleCloseAlertMsg('success');
            NavigateTo('leads');
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Some Error Please Try Again');
        }
    }

    const NavigateTo = (route) => {
        navigate('/' + route, {});
    }

    const HandleGetLeadListSuccessResponse = (res) => {
        if (res != false && res != 'error') {

            setLeadDetails(res.data.leadlistresponse.rows);

            BindLeadDetails(res.data.leadlistresponse.rows[0]);
        }
        else {
            setLeadDetails([]);
        }
        setGetLeadDetails(false);
    }

    const BindLeadDetails = (leadData) => {
        // let leadData = leadDetails[0];
        setLeadFormData((prev) => ({ ...prev, 'txtCandidateName': leadData.user_name }));
        setLeadFormData((prev) => ({ ...prev, 'txtMobileNumber': leadData.user_mobile }));
        setLeadFormData((prev) => ({
            ...prev,
            'txtEmailId': leadData.user_email,
            'ddlLeadState': leadData.user_state,
            'ddlLeadDistrict': leadData.user_district,
            'ddlCandidateGender': leadData.user_gender,
            'txtCandidateAge': leadData.user_age,
            'ddlCandidateExp': leadData.user_exp,
            'ddlCandidateQual': leadData.user_qual,
            'ddlCandidateBatchTime': leadData.user_batch_time,
        }));
        setLeadFormData((prev) => ({ ...prev, 'ddlLeadSource': leadData.lead_source }));
        setLeadFormData((prev) => ({ ...prev, 'ddlLeadDepartment': leadData.lead_dept }));
        setLeadFormData((prev) => ({ ...prev, 'ddlLeadOwner': leadData.lead_owner }));
        //alert(leadData.lead_status);
        setLeadFormData((prev) => ({ ...prev, 'ddlLeadStatus': leadData.lead_status }));
        setLeadFormData((prev) => ({ ...prev, 'txtLeadDesc': leadData.lead_desc }));
        // if (leadData.lead_status === 'Interview Scheduled') {
        setLeadFormData((prev) => ({ ...prev, 'ddlInterviewerName': leadData.interviewer_name }));
        setLeadFormData((prev) => ({ ...prev, 'txtInterviewDate': leadData.interview_date }));
        // }
        // if (leadData.interview_status === 'Joined') {
        setLeadFormData((prev) => ({ ...prev, 'txtJoiningDate': leadData.joining_date }));
        setLeadFormData((prev) => ({ ...prev, 'ddlClassMode': leadData.joining_class_mode }));
        setLeadFormData((prev) => ({ ...prev, 'txtPatchDateTime': leadData.patch_date_time }));
        // }
        setGetCityList(true)
    }

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');

        }, 3000)

    }

    const HandleUpdateLeadResponse = (res) => {
        //  console.log(res);

        if (res != false) {
            setGetLeadDetails(true);
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.leadupdateresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Please Try Again');
        }


        setEditLead(false);
    }

    const HandleStateListResponse = (res) => {
        //  console.log(res.data.statelistresponse.rows);
        if (res != false) {
            setStateListData(res.data.statelistresponse.rows);
        }
        else {
            setStateListData([]);
        }
        setGetStateList(false)
    }


    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfileListData(profileListData);
        }
        else {
            setProfileListData([]);
        }
        setGetProfileList(false);
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const GetProjectDetails = () => {
        ToggleProjectDetailsBox();
    }

    const HandleUpdateLeadDescResponse = (res) => {
        if (mode == 'edit') {
            setGetLeadDetails(true);
        }
        ToggleDescriptionBox();
        setUpdateLeadDesc(false);
    }










    return (
        <Box>
            <LeadDetailsComp
                mystate={state}
                HandleInputs={HandleInputs}
                NavigateTo={NavigateTo}
                cityListData={cityListData}
                areaListData={areaListData}
                projectList={projectList}
                LeadFormData={LeadFormData}
                SaveOrUpdateLead={SaveOrUpdateLead}
                ToggleDescriptionBox={ToggleDescriptionBox}
                AddDescription={AddDescription}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                GetProjectDetails={GetProjectDetails}
                ToggleProjectDetailsBox={ToggleProjectDetailsBox}
            />
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((getProfileList === true) ? GetProfileList(pnkstore, {}, userData.getState().token, HandleGetProfilesListSuccessResponse) : "")}
            {((getStateList === true) ? GetStatesList(pnkstore, userData.getState().token, HandleStateListResponse) : "")}
            {((getCityList === true) ? GetDistrictList(pnkstore, LeadFormData.ddlLeadState, userData.getState().token, HandleCityListResponse) : "")}
            {((getAreaList === true) ? GetAreasList(pnkstore, LeadFormData.ddlLeadDistrict, userData.getState().token, HandleAreaListResponse) : "")}
            {((addLead === true) ? AddNewLead(pnkstore, LeadFormData, userData.getState().token, HandleAddNewLeadResponse) : "")}
            {((editLead === true) ? UpdateLead(pnkstore, LeadFormData, userData.getState().token, HandleUpdateLeadResponse) : "")}
            {((getLeadDetails === true) ? GetAllLeads(pnkstore, leadSearchObj, userData.getState().token, HandleGetLeadListSuccessResponse) : "")}
            {((updateLeadDesc === true) ? UpdateLeadDesc(pnkstore, LeadFormData, userData.getState().token, HandleUpdateLeadDescResponse) : "")}
        </Box>
    )
}